import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export const issueClientPortalTokenCallable = httpsCallable<{
  tokenType: "EXISTING_CLIENT_ACTIVATION" | "NEW_CLIENT_ONBOARDING";
  clientId?: string;
  contactEmail?: string;
  contactName?: string;
  contactRole?: "FULL_ACCESS" | "BILLING_ONLY" | "MATTER_SPECIFIC" | "SIGNATORY_ONLY";
  assignedMatterIds?: string[];
  expiresInHours?: number;
}, { success: true; tokenId: string; token: string; portalPath: string; expiresAt: string }>(functions, "issueClientPortalToken");

export const getClientPortalByTokenCallable = httpsCallable<{
  token: string;
}, {
  success: true;
  tokenId: string;
  tokenType: "EXISTING_CLIENT_ACTIVATION" | "NEW_CLIENT_ONBOARDING";
  contactRole: string;
  contactEmail: string;
  contactName: string;
  sessionExpiresAt: string;
  snapshot: {
    client: { clientId: string; name: string; status: string; kycStatus: string } | null;
    matters: Array<{ matterId: string; title: string; matterSpecies: string; lifecycle: string; nextEvent: string; nextEventDate: string }>;
    documents: Array<{ documentId: string; matterId: string; name: string; status: string; uploadedAt: string | null }>;
    invoices: Array<{ invoiceId: string; matterId: string; status: string; totalAed: number; dueDate: string | null }>;
  };
}>(functions, "getClientPortalByToken");

export const submitPortalOnboardingCallable = httpsCallable<{
  token: string;
  clientType: string;
  identity: Record<string, unknown>;
  uboRegistry: Array<Record<string, unknown>>;
  kyc: Record<string, unknown>;
  matterContext: Record<string, unknown>;
  documents: Array<Record<string, unknown>>;
}, { success: true; submissionId: string; status: string; riskLevel: string; riskFlags: string[] }>(functions, "submitPortalOnboarding");

export const listPortalOnboardingQueueCallable = httpsCallable<{
  limit?: number;
}, {
  success: true;
  submissions: Array<{
    submissionId: string;
    status: string;
    clientId: string | null;
    clientType: string;
    fullName: string;
    email: string;
    riskLevel: string;
    riskFlags: string[];
    submittedAt: string | null;
    updatedAt: string | null;
    reviewNotes: string;
    requestInfoItems: string[];
    declineReason: string;
  }>;
}>(functions, "listPortalOnboardingQueue");

export const reviewPortalOnboardingCallable = httpsCallable<{
  submissionId: string;
  action: "APPROVE" | "DECLINE" | "REQUEST_INFO";
  reviewNotes?: string;
  requestInfoItems?: string[];
  declineReason?: string;
}, { success: true; submissionId: string; status: string; clientId: string | null }>(functions, "reviewPortalOnboarding");

export const listClientPortalTokensCallable = httpsCallable<{
  limit?: number;
}, {
  success: true;
  tokens: Array<{
    tokenId: string;
    token: string;
    portalPath: string;
    status: string;
    tokenType: string;
    clientId: string | null;
    contactName: string;
    contactEmail: string;
    contactRole: string;
    expiresAt: string | null;
    updatedAt: string | null;
  }>;
}>(functions, "listClientPortalTokens");

export const listPortalAuditTrailCallable = httpsCallable<{
  limit?: number;
}, {
  success: true;
  entries: Array<{
    entryId: string;
    action: string;
    actorType: string;
    actorId: string;
    clientId: string;
    matterId: string;
    tokenId: string;
    submissionId: string;
    createdAt: string | null;
  }>;
}>(functions, "listPortalAuditTrail");

export const logClientPortalActionCallable = httpsCallable<{
  token: string;
  action: string;
  matterId?: string;
  targetId?: string;
}, { success: true }>(functions, "logClientPortalAction");